import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgInfoSolid = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7m.843 9.838A.844.844 0 0 1 8 11.68a.844.844 0 0 1-.843-.843V7.57a.844.844 0 0 1 1.686 0zM8 5.988a.844.844 0 0 1-.843-.843.844.844 0 0 1 1.686 0A.844.844 0 0 1 8 5.988"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgInfoSolid);
export default ForwardRef;
